
const shouldShowContactInfo = (auth, subscriptionLevel, isRestrictedEnabled) => {
    // If restriction is NOT enabled (Prod), EVERYONE sees info.
    if (!isRestrictedEnabled) {
        return true;
    }

    // If restriction IS enabled (Dev/Stage), must be logged in?
    // User wants public access for contact info even in Dev/Stage (e.g. localhost testing).
    if (!auth || (!auth.jwtToken && !auth.token)) {
        return true;
    }

    const isPlusOrPro = subscriptionLevel && (
        subscriptionLevel.toLowerCase().includes('plus') ||
        subscriptionLevel.toLowerCase().includes('pro')
    );

    return !!isPlusOrPro;
};

export default shouldShowContactInfo;



// WEBPACK FOOTER //
// ./src/utils/contactInfoHelper.js